module.exports = __webpack_public_path__ + "easeInTop.gif";